import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

export type TDashboardGridProps = {
  children?: ReactNode
  className?: string
}

export function DashboardGrid({ children, className }: TDashboardGridProps) {
  return (
    <div className={cn("grid gap-4 md:grid-cols-2 lg:grid-cols-3", className)}>
      {children}
    </div>
  )
}
